import React from 'react'
import { ReactComponent as CloseIcon } from "../../svg/close.svg";

export default class CustomModalHeader extends React.Component {

  render(){
    const { title, headerClass, close } = this.props
    let className = 'modal__h'
    if(headerClass){
      className += ` ${headerClass}`
    }
    return (
      <div className={className}>
        <span className='modal__h__title'>
          {title}
        </span>
        <CloseIcon 
          className='modal__h__close'
          style={{
            fill: '#000',
            stroke: '#000'
          }}
          onClick={() => close()} 
        />
      </div>
    )
  }

}